"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleEventCalendar = void 0;
const daygrid_1 = __importDefault(require("@fullcalendar/daygrid"));
const interaction_1 = __importDefault(require("@fullcalendar/interaction"));
const react_1 = __importDefault(require("@fullcalendar/react"));
const timegrid_1 = __importDefault(require("@fullcalendar/timegrid"));
const addDays_1 = __importDefault(require("date-fns/addDays"));
const addMinutes_1 = __importDefault(require("date-fns/addMinutes"));
const areIntervalsOverlapping_1 = __importDefault(require("date-fns/areIntervalsOverlapping"));
const differenceInHours_1 = __importDefault(require("date-fns/differenceInHours"));
const isBefore_1 = __importDefault(require("date-fns/isBefore"));
const max_1 = __importDefault(require("date-fns/max"));
const min_1 = __importDefault(require("date-fns/min"));
const set_1 = __importDefault(require("date-fns/set"));
const subMinutes_1 = __importDefault(require("date-fns/subMinutes"));
const react_2 = __importStar(require("react"));
const Alert_1 = __importDefault(require("react-bootstrap/Alert"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const configContext_1 = require("../../context/configContext");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const DayPickerCustomInput_1 = require("../day-picker/DayPickerCustomInput");
const Spinner_1 = require("../spinner/Spinner");
const ValidationErrors_1 = require("../ValidationErrors");
require("./Calendar.scss");
const deLocale = require("@fullcalendar/core/locales/de");
class ValidationErrorsCalendar extends ValidationErrors_1.ValidationErrors {
    constructor() {
        super(...arguments);
        this.dateInvalid = "";
        this.timeInvalid = "";
        this.overlap = "";
    }
}
/**
 * Calendar where the user can select and change a single event.
 *
 * Also contains a date picker and time chooser as alternative to clicking into the calendar.
 */
const SingleEventCalendar = (props) => {
    const [breakEvents, setBreakEvents] = (0, react_2.useState)([]);
    const [validationErrors, setValidationErrors] = (0, react_2.useState)(new ValidationErrorsCalendar());
    const calendarComponentRef = (0, react_2.useRef)(null);
    /** Generate booking times for dropdown from 06:00 to 24:00. */
    const timeOptionElements = (0, react_2.useMemo)(() => {
        return Array.from(Array(37), (x, index) => {
            const time = index / 2 + 6;
            return `${Math.floor(time).toString().padStart(2, "0")}:${time % 1 === 0 ? "00" : "30"}`;
        }).map((time) => react_2.default.createElement("option", { key: time }, time));
    }, []);
    const config = (0, configContext_1.useConfig)();
    // Validate if event changes.
    (0, react_2.useEffect)(() => {
        const newValidationErrors = validate(props.bookingEvent.start, props.bookingEvent.end, props.configResource, props.busyEvents, config);
        setValidationErrors(newValidationErrors);
        props.isValidChange(!newValidationErrors.hasErrors());
    }, [props.bookingEvent, props.configResource, props.busyEvents]);
    /**
     * If the busy events changed we must update the pre- and post break events.
     * This adds some time before and after every event to allow time between two bookings.
     */
    (0, react_2.useEffect)(() => {
        if (props.configResource.breakBetweenBookings > 0) {
            // Pre event break.
            const preBusyEvents = props.busyEvents.map((event) => ({
                start: (0, subMinutes_1.default)(event.start, props.configResource.breakBetweenBookings),
                end: event.start,
                rendering: "background",
                classNames: ["pre-busy"],
            }));
            // Post event break.
            const postBusyEvents = props.busyEvents.map((event) => ({
                start: event.end,
                end: (0, addMinutes_1.default)(event.end, props.configResource.breakBetweenBookings),
                rendering: "background",
                classNames: ["post-busy"],
            }));
            setBreakEvents([...preBusyEvents, ...postBusyEvents]);
        }
    }, [props.busyEvents]);
    const event = {
        start: props.bookingEvent.start,
        end: props.bookingEvent.end,
        title: props.eventTitle ? props.eventTitle : "Hier buchen?",
        id: "current",
    };
    // HACK for touch: Fullcalendar only works with long touch and then drag for touch devices.
    // We keep track of the internal instance id and manually set it as eventSelection. This
    // allows us to do event resizing without first having to click or long-click.
    (0, react_2.useEffect)(() => {
        var _a, _b, _c;
        if (calendarComponentRef.current) {
            calendarComponentRef.current.getApi().state.eventSelection =
                (_c = (_b = (_a = calendarComponentRef.current.getApi().getEventById("current")) === null || _a === void 0 ? void 0 : _a._instance) === null || _b === void 0 ? void 0 : _b.instanceId) !== null && _c !== void 0 ? _c : "";
            calendarComponentRef.current.getApi().render();
        }
    }, [event]);
    /** Handles the click in the calender. */
    function handleDateClick(arg) {
        // By default use a duration of 120 minutes.
        handleDateTimeChange(arg.date, (0, addMinutes_1.default)(arg.date, 120));
    }
    /** Handles the selection of a duration with the mouse in the calendar. */
    function handleDateSelect(arg) {
        handleDateTimeChange(arg.start, arg.end);
        calendarComponentRef.current.getApi().unselect();
    }
    /** Handles the start time change of the select dropdown. */
    function handleStartTimeSelectChange(startTime) {
        const start = dateUtils.dateSetTime(props.bookingEvent.start, dateUtils.parseTime(startTime));
        handleDateTimeChange(start, props.bookingEvent.end);
    }
    /** Handles the end time change of the select dropdown. */
    function handleEndTimeSelectChange(endTime) {
        const end = dateUtils.dateSetTime(props.bookingEvent.start, // Use start date as reference.
        dateUtils.parseTime(endTime));
        handleDateTimeChange(props.bookingEvent.start, end);
    }
    /** Handles the change of the date field. */
    function handleDateChange(date) {
        const start = (0, set_1.default)(props.bookingEvent.start, {
            year: date.getFullYear(),
            month: date.getMonth(),
            date: date.getDate(),
        });
        let end = (0, set_1.default)(props.bookingEvent.end, {
            year: date.getFullYear(),
            month: date.getMonth(),
            date: date.getDate(),
        });
        // Special handling of 24:00 end time because this is 00:00 on the next day.
        if (end.getHours() === 0 &&
            end.getMinutes() === 0 &&
            end.getSeconds() === 0 &&
            end.getMilliseconds() === 0) {
            end = (0, addDays_1.default)(end, 1);
        }
        props.onBookingEventChange({
            start,
            end,
        });
        calendarComponentRef.current.getApi().gotoDate(start);
    }
    /** Handles the change in the start and/or end date. */
    function handleDateTimeChange(start, end) {
        let validStart = start;
        let validEnd = end;
        // Ensure that we are inside min and max time of one day.
        const minTime = dateUtils.dateSetTime(validStart, dateUtils.parseTime(props.configResource.minTime));
        const maxTime = dateUtils.dateSetTime(validStart, // Use the start date as reference.
        dateUtils.parseTime(props.configResource.maxTime));
        validStart = (0, max_1.default)([validStart, minTime]);
        validEnd = (0, min_1.default)([validEnd, maxTime]);
        // Ensure minimum duration of one hour.
        if ((0, differenceInHours_1.default)(validEnd, validStart) < 1) {
            validEnd = (0, addMinutes_1.default)(validStart, 60);
            if (validEnd > maxTime) {
                validEnd = maxTime;
                validStart = (0, subMinutes_1.default)(validEnd, 60);
            }
            if (validStart < minTime) {
                validStart = minTime;
                validEnd = (0, addMinutes_1.default)(validStart, 60);
            }
            // Do a random change to force an update of the calendar. Otherwise if the event
            // was one hour and user moved to half hour, the view would not update.
            props.onBookingEventChange({ start: minTime, end: minTime });
        }
        props.onBookingEventChange({
            start: validStart,
            end: validEnd,
        });
    }
    let errorOrWarningMessage;
    if (validationErrors.hasErrors()) {
        if (props.showErrors || props.showWarnings) {
            errorOrWarningMessage = (react_2.default.createElement(Alert_1.default, { className: "mt-3", variant: props.showErrors ? "danger" : "warning" },
                react_2.default.createElement("ul", { className: "list-unstyled mb-0" }, [
                    validationErrors.dateInvalid,
                    validationErrors.timeInvalid,
                    validationErrors.overlap,
                ].map((msg, index) => {
                    if (msg !== "") {
                        return (react_2.default.createElement("li", { key: index, dangerouslySetInnerHTML: { __html: msg } }));
                    }
                    else {
                        return null;
                    }
                }))));
        }
    }
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("div", { className: "mb-3" },
            react_2.default.createElement(Row_1.default, { className: "date-time-fields" },
                react_2.default.createElement(Col_1.default, { sm: 6, lg: 4 },
                    react_2.default.createElement(Form_1.default.Group, { controlId: "date" },
                        react_2.default.createElement(Form_1.default.Label, null,
                            "Datum ",
                            react_2.default.createElement("small", null, "(in Kalender klicken)")),
                        react_2.default.createElement(DayPickerCustomInput_1.DayPickerCustomInput, { id: "date", date: props.bookingEvent.start, onDateChange: (date) => handleDateChange(date), isInvalid: props.showErrors && validationErrors.dateInvalid !== "", todayButton: "Heute", editable: true, minDate: props.minDate, maxDate: props.maxDate }))),
                react_2.default.createElement(Col_1.default, { xs: 6, sm: 3, lg: 4 },
                    react_2.default.createElement(Form_1.default.Group, { controlId: "startTime" },
                        react_2.default.createElement(Form_1.default.Label, null, "Zeit von"),
                        react_2.default.createElement(Form_1.default.Control, { as: "select", value: dateUtils.formatTime(props.bookingEvent.start), onChange: (e) => handleStartTimeSelectChange(e.target.value), isInvalid: props.showErrors && validationErrors.timeInvalid !== "" }, timeOptionElements))),
                react_2.default.createElement(Col_1.default, { xs: 6, sm: 3, lg: 4 },
                    react_2.default.createElement(Form_1.default.Group, { controlId: "endTime" },
                        react_2.default.createElement(Form_1.default.Label, null, "Zeit bis"),
                        react_2.default.createElement(Form_1.default.Control, { as: "select", value: dateUtils.formatTime(props.bookingEvent.end), onChange: (e) => handleEndTimeSelectChange(e.target.value), isInvalid: props.showErrors && validationErrors.timeInvalid !== "" }, timeOptionElements))))),
        react_2.default.createElement("div", { className: "single-event-calendar calendar-wrapper" },
            react_2.default.createElement(react_1.default, { ref: calendarComponentRef, defaultView: "timeGridWeek", header: {
                    left: "prev,next today",
                    center: "",
                    right: "title",
                }, titleFormat: { year: "numeric", month: "short" }, locale: deLocale, allDaySlot: false, businessHours: props.configResource.businessHours, minTime: props.configResource.minTime, maxTime: props.configResource.maxTime, contentHeight: () => {
                    if (calendarComponentRef.current) {
                        const width = calendarComponentRef.current.getApi().el.clientWidth;
                        if (width > 800) {
                            return 550;
                        }
                        else if (width > 450) {
                            return width / 1.4;
                        }
                        else {
                            return width / 1.2;
                        }
                    }
                    else {
                        return 500;
                    }
                }, scrollTime: "07:30", displayEventTime: true, displayEventEnd: true, timeZone: "local", editable: !props.isBusyEventsLoading, selectable: !props.isBusyEventsLoading, selectMirror: true, defaultDate: props.bookingEvent.start, validRange: { start: props.minDate, end: props.maxDate }, eventLongPressDelay: 0, selectLongPressDelay: 1000, plugins: [daygrid_1.default, timegrid_1.default, interaction_1.default], datesRender: (info) => {
                    var _a, _b;
                    // Only update state if the visible date actually changed.
                    // Otherwise we end up in a infinite loop.
                    if (info.view.currentStart.getTime() !=
                        ((_a = props.visibleDates) === null || _a === void 0 ? void 0 : _a.from.getTime()) ||
                        info.view.currentEnd.getTime() != ((_b = props.visibleDates) === null || _b === void 0 ? void 0 : _b.to.getTime())) {
                        props.onVisibleDatesChange({
                            from: info.view.currentStart,
                            to: info.view.currentEnd,
                        });
                    }
                }, select: handleDateSelect, dateClick: handleDateClick, eventDrop: (arg) => {
                    if (arg.event.start && arg.event.end) {
                        handleDateTimeChange(arg.event.start, arg.event.end);
                    }
                }, eventResize: (arg) => {
                    if (arg.event.start && arg.event.end) {
                        handleDateTimeChange(arg.event.start, arg.event.end);
                    }
                }, eventRender: (arg) => {
                    if (arg.event.rendering === "background") {
                        arg.el.innerHTML = `<div class="fc-title">${arg.event.title}</div>`;
                    }
                }, events: [event, ...props.busyEvents, ...breakEvents] }),
            props.isBusyEventsLoading && (react_2.default.createElement("div", { className: "calendar-loading" },
                react_2.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" }),
                react_2.default.createElement("div", null, "Buchungen werden geladen...")))),
        errorOrWarningMessage));
};
exports.SingleEventCalendar = SingleEventCalendar;
/**
 * Validates the chosen date.
 */
function validate(start, end, configResource, busyEvents, config) {
    const errors = new ValidationErrorsCalendar();
    // Test if in the past.
    if ((0, isBefore_1.default)(start, new Date())) {
        errors.dateInvalid = "Gewählter Zeitraum liegt in der Vergangenheit.";
        return errors;
    }
    // Test business hours.
    const relevantBusinessHours = configResource.businessHours.filter((bh) => bh.daysOfWeek.includes(start.getDay()));
    const invalidBusinessHoursText = `Zeitraum liegt ausserhalb der Öffnungszeiten. Lass uns reden, vielleicht finden wir einen Weg: <a href="mailto:${config.email}">${config.email}</a>`;
    if (relevantBusinessHours.length <= 0) {
        errors.dateInvalid = invalidBusinessHoursText;
        return errors;
    }
    else {
        const startTime = dateUtils.formatTime(start);
        const endTime = dateUtils.formatTime(end);
        const insideBusinessHours = relevantBusinessHours.some((bh) => startTime >= bh.startTime && endTime <= bh.endTime);
        if (!insideBusinessHours) {
            errors.timeInvalid = invalidBusinessHoursText;
            return errors;
        }
    }
    // Test overlap with other busy events.
    const overlap = busyEvents.some((busyEvent) => {
        return (0, areIntervalsOverlapping_1.default)({
            // Add some time before and after every event to allow breaks between two bookings.
            start: (0, subMinutes_1.default)(busyEvent.start, configResource.breakBetweenBookings),
            end: (0, addMinutes_1.default)(busyEvent.end, configResource.breakBetweenBookings),
        }, { start: start, end: end });
    });
    if (overlap) {
        errors.overlap =
            "Die Zeit überschneidet sich mit einer anderen Buchung. Bitte anderen Zeitraum wählen.";
        return errors;
    }
    return errors;
}
